import { SearchTypeTab } from '@lmt/unicorn-shared/app/components/search/SearchTypeTab';
import { SearchType } from '@lmt/unicorn-shared/app/components/search/types';
import React, { FC, useState } from 'react';
import { ReactNode } from 'react';

import styles from './ExtendedSearchPageHeader.module.scss';

type Props = {
  defaultCurrentTab?: SearchType;
  children?: ReactNode;
};

const tabs = Object.values(SearchType);

export const ExtendedSearchPageHeader: FC<Props> = (props) => {
  const [currentTab, setCurrentTab] = useState(
    props.defaultCurrentTab ?? SearchType.Patients,
  );

  return (
    <div className={styles.container}>
      <div className={styles.tabs}>
        {tabs.map((tab) => (
          <SearchTypeTab
            key={tab}
            isSelected={tab === currentTab}
            title={tab}
            onClick={setCurrentTab}
          />
        ))}
      </div>
      {props.children}
    </div>
  );
};
